




























































































import Vue from 'vue'
import PieChart from '@/components/dashboard/PieChart.vue'
import ColumnChart from '@/components/dashboard/ColumnChart.vue'
import DashboardTable from '@/components/dashboard/DashboardTable.vue'
import GanttChart from '@/components/dashboard/GanttChart.vue'
import Messages from '@/components/dashboard/Messages.vue'
import HolidayBalanceChart from '@/components/dashboard/HolidayBalanceChart.vue'
import { FETCH_DASHBOARD_DATA } from '@/store/action-types'
import moment from 'moment'
import _ from 'lodash'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DashboardData } from '@/model/dashboard/DashboardData'
import { GanttChartData } from '@/model/dashboard/GanttChartData'
import { DashboardMessage } from '@/model/dashboard/DashboardMessage'
import { DailyTableData } from '@/model/dashboard/DailyTableData'
import { PieChartData } from '@/model/dashboard/PieChartData'
import { ColumnChartData } from '@/model/dashboard/ColumnChartData'
import { DashboardGanttEmployeeList } from '@/types'
import ColumnInverseChart from '@/components/dashboard/ColumnInverseChart.vue'
import GanttChartScheduleWeek from '@/components/dashboard/GanttChartScheduleWeek.vue'

interface ComponentData {
  componentTypeMap: Map<string, string>
  data: Array<DashboardData>
  employees: DashboardGanttEmployeeList
  ganttLabel: string
  ganttChartData: Array<GanttChartData>
  ganttDate: string
  columnChartLabel: string
  columnChartData: Array<ColumnChartData>
  columnChartDate: string
  columnInverseChartLabel: string
  columnInverseChartData: Array<ColumnChartData>
  columnInverseChartDate: string
  pieChartLabel: string
  pieChartData: Array<PieChartData>
  messagesLabel: string
  messagesData: Array<DashboardMessage>
  isMessagesData: boolean
  dashboardTableLabel: string
  dashboardTableHeaders: Array<any>
  dashboardTableData: Array<DailyTableData>
  dashboardTableDate: string
  ganttLabelScheduleWeek: string
  ganttChartScheduleWeekData: Array<GanttChartData>
  ganttDateScheduleWeek: string
}

export default Vue.extend({
  name: 'DashboardPage',

  components: {
    PieChart,
    ColumnChart,
    DashboardTable,
    GanttChart,
    Messages,
    HolidayBalanceChart,
    ColumnInverseChart,
    GanttChartScheduleWeek
  },

  data (): ComponentData {
    return {
      componentTypeMap: new Map([
        ['w_schedule_daily', 'GanttChart'], ['w_capacity_by_employee', 'ColumnChart'],
        ['w_capacity_percentage', 'PieChart'], ['w_messages', 'Messages'], ['w_schedule_daily_table', 'DashboardTable'],
        ['w_bvg_by_employee', 'ColumnInverseChart'], ['w_schedule_week', 'GanttChartScheduleWeek']
      ]),
      data: [],
      employees: [],
      ganttLabel: '',
      ganttChartData: [],
      ganttDate: '',
      columnChartLabel: '',
      columnChartData: [],
      columnChartDate: '',
      columnInverseChartLabel: '',
      columnInverseChartData: [],
      columnInverseChartDate: '',
      pieChartLabel: '',
      pieChartData: [],
      messagesLabel: '',
      messagesData: [],
      isMessagesData: false,
      dashboardTableLabel: '',
      dashboardTableHeaders: [
        { text: this.$t('dashboard.employee').toString(), align: 'left', value: 'employee' },
        { text: this.$t('dashboard.time').toString(), align: 'left', value: 'time' },
        { text: this.$t('dashboard.entry').toString(), align: 'left', value: 'entry' },
        { text: this.$t('dashboard.conflict').toString(), align: 'left', value: 'conflict' }
      ],
      dashboardTableData: [],
      dashboardTableDate: '',
      ganttLabelScheduleWeek: '',
      ganttChartScheduleWeekData: [],
      ganttDateScheduleWeek: ''
    }
  },

  computed: {
    dashboardItemListFirstRow (): Array<DashboardData> | undefined {
      if (this.data && this.ganttChartData) {
        return _.sortBy(this.data.filter((item: DashboardData) => item.rowPosition === 1), ['columnPosition'])
      } else {
        return undefined
      }
    },

    dashboardItemListSecondRow (): Array<DashboardData> | undefined {
      if (this.data && this.columnChartData) {
        return _.sortBy(this.data.filter((item: DashboardData) => item.rowPosition === 2), ['columnPosition'])
      } else {
        return undefined
      }
    },

    dashboardItemListThirdRow (): Array<DashboardData> | undefined {
      if (this.data && this.columnChartData) {
        return _.sortBy(this.data.filter((item: DashboardData) => item.rowPosition === 3), ['columnPosition'])
      } else {
        return undefined
      }
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    componentClass (item: string): string | undefined {
      if (this.componentTypeMap.get(item) === 'GanttChart') {
        return 'gantt'
      } else if (this.componentTypeMap.get(item) === 'ColumnChart') {
        return 'capacityChart'
      } else if (this.componentTypeMap.get(item) === 'PieChart') {
        return 'pieChart'
      } else if (this.componentTypeMap.get(item) === 'Messages') {
        return 'messages'
      } else if (this.componentTypeMap.get(item) === 'DashboardTable') {
        return 'table'
      } else if (this.componentTypeMap.get(item) === 'ColumnInverseChart') {
        return 'columnInverseChart'
      } else if (this.componentTypeMap.get(item) === 'GanttChartScheduleWeek') {
        return 'ganttWeek'
      } else {
        return undefined
      }
    },

    createGanttChartData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.ganttLabel = data.widgetName
        this.ganttDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.ganttChartData = data.widgetData
        const filteredData: any = _.uniqBy(data.widgetData, 'name')
        this.employees = filteredData.map((item: GanttChartData) => {
          return { name: item.name }
        })
      }
    },

    createGanttChartScheduleWeekData (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.ganttLabelScheduleWeek = data.widgetName
        this.ganttDateScheduleWeek = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.ganttChartScheduleWeekData = data.widgetData
        const filteredData: any = _.uniqBy(data.widgetData, 'name')
        this.employees = filteredData.map((item: GanttChartData) => {
          return { name: item.name }
        })
      }
    },

    createMessagesTable (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.messagesLabel = data.widgetName
        this.isMessagesData = true
        if (data.widgetData) {
          this.messagesData = data.widgetData
        }
      } else {
        this.messagesLabel = data.widgetName
        this.isMessagesData = false
      }
    },

    createDashboardTable (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        this.dashboardTableLabel = data.widgetName
        this.dashboardTableDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.dashboardTableData = data.widgetData
      }
    },

    createPieChart (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        const month: string = moment(data.lastUpdatedDate).locale(this.selectedLanguage).format('MMMM')
        this.pieChartLabel = `${data.widgetName} - ${month}`
        this.pieChartData = data.widgetData
      }
    },

    createColumnChart (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        const month: string = moment(data.lastUpdatedDate).locale(this.selectedLanguage).format('MMMM')
        this.columnChartLabel = `${data.widgetName} - ${month}`
        this.columnChartDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.columnChartData = data.widgetData
      }
    },

    createColumnInverseChart (data: DashboardData): void {
      if (data && data.widgetName && data.widgetData) {
        const month: string = moment(data.lastUpdatedDate).locale(this.selectedLanguage).format('MMMM')
        this.columnInverseChartLabel = `${data.widgetName} - ${month}`
        this.columnInverseChartDate = `${this.$t('dashboard.updated')}: ${moment(data.lastUpdatedDate).format('DD.MM.YYYY HH:mm')}`
        this.columnInverseChartData = data.widgetData
      }
    },

    async fetchDashboardData (): Promise<void> {
      this.data = await this.$store.dispatch(FETCH_DASHBOARD_DATA)

      if(this.data.length === 1) {
        document.documentElement.style.setProperty('--chart-height', '100%')
      } else {
        document.documentElement.style.setProperty('--chart-height', '40vh')
      }

      this.data.forEach((item: DashboardData) => {
        if (item.code === 'w_schedule_daily') {
          this.createGanttChartData(item)
        } else if (item.code === 'w_messages') {
          this.createMessagesTable(item)
        } else if (item.code === 'w_schedule_daily_table') {
          this.createDashboardTable(item)
        } else if (item.code === 'w_capacity_percentage') {
          this.createPieChart(item)
        } else if (item.code === 'w_capacity_by_employee') {
          this.createColumnChart(item)
        } else if (item.code === 'w_bvg_by_employee') {
          this.createColumnInverseChart(item)
        } else if (item.code === 'w_schedule_week') {
          this.createGanttChartScheduleWeekData(item)
        }
      })
    },

    onDashboardSettingsButtonClick () {
      this.$router.push('dashboard-settings')
    }
  },

  created () {
    this.fetchDashboardData()
  }

})
